export const GET_FACING_DIRECTION = '[Facing Direction Action] Get Facing Direction';
export const CONFIRMED_GET_FACING_DIRECTION = '[Facing Direction Action] Confirmed Get Facing Direction';
